import template from './sw-entity-premium-description.html.twig';
import './sw-entity-premium-description.scss';
import SwEntityPurchaseButton from "../sw-entity-purchase-button";

const {
    Component
} = Shopware;

export default Component.wrapComponentConfig({
    template: template,
    components: {
      SwEntityPurchaseButton
    },
    computed: {
        hideText() {
            return Shopware.InAppPurchase.isActive('VerignDvAccessibilitySw6', 'VerignPremiumAccessibilityPremiumSub');
        }
    },
    data() {
        return {
            premiumDescription: this.$tc('verignDvAccessibility.premiumDescription'),
            premiumPurchasedDescription: this.$tc('verignDvAccessibility.premiumDescription')
        }
    }
});